// extracted by mini-css-extract-plugin
export var orderDetails = "_pq-2";
export var orderImage = "_pq-1";
export var orderMeta = "_pq-3";
export var orderSummary = "_pq-0";
export var rightArrow = "_pq-4";